import { defineMessages } from 'react-intl';

export default defineMessages({
  'reportMetadata.grains.None': { id: 'reportMetadata.grains.None', defaultMessage: 'None' },
  'reportMetadata.grains.Hour': { id: 'reportMetadata.grains.Hour', defaultMessage: 'Hourly' },
  'reportMetadata.grains.Day': { id: 'reportMetadata.grains.Day', defaultMessage: 'Daily' },
  'reportMetadata.grains.Week': { id: 'reportMetadata.grains.Week', defaultMessage: 'Weekly' },
  'reportMetadata.grains.Month': { id: 'reportMetadata.grains.Month', defaultMessage: 'Monthly' },
  'reportMetadata.grains.MonthAndYear': { id: 'reportMetadata.grains.MonthAndYear', defaultMessage: 'Monthly' },
  'reportMetadataColumns.ImpressionsServed': { id: 'reportMetadataColumns.ImpressionsServed', defaultMessage: 'Filled impressions' },
  'reportMetadataColumns.ImpressionsViewed': { id: 'reportMetadataColumns.ImpressionsViewed', defaultMessage: 'Viewable impressions' },
  'reportMetadataColumns.Viewability': { id: 'reportMetadataColumns.Viewability', defaultMessage: 'Viewability rate' },
  'reportMetadataColumns.Revenue': { id: 'reportMetadataColumns.Revenue', defaultMessage: 'Revenue' },
  'reportMetadataColumns.FillRate': { id: 'reportMetadataColumns.FillRate', defaultMessage: 'Fill rate' },
  'reportMetadataColumns.eCPM': { id: 'reportMetadataColumns.eCPM', defaultMessage: 'eCPM' },
  'reportMetadataColumns.Clicks': { id: 'reportMetadataColumns.Clicks', defaultMessage: 'Clicks' },
  'reportMetadataColumns.CTR': { id: 'reportMetadataColumns.CTR', defaultMessage: 'CTR' },
  'reportMetadataColumns.DateTime': { id: 'reportMetadataColumns.DateTime', defaultMessage: 'Date' },
  'reportMetadataColumns.AdUnitName': { id: 'reportMetadataColumns.AdUnitName', defaultMessage: 'Ad unit' },
  'reportMetadataColumns.AdType': { id: 'reportMetadataColumns.AdType', defaultMessage: 'Ad type' },
  'reportMetadataColumns.PropertyUrl': { id: 'reportMetadataColumns.PropertyUrl', defaultMessage: 'Site URL' },
  'reportMetadataColumns.Country': { id: 'reportMetadataColumns.Country', defaultMessage: 'Country' },
  'reportMetadataColumns.CurrencyCode': { id: 'reportMetadataColumns.CurrencyCode', defaultMessage: 'Currency' },
  'reportMetadataColumns.Currency': { id: 'reportMetadataColumns.Currency', defaultMessage: 'Currency' },
  'reportMetadataColumns.AccountName': { id: 'reportMetadataColumns.AccountName', defaultMessage: 'Account Name' },
  'reportMetadataColumns.Impressions': {
    id: 'reportMetadataColumns.Impressions',
    defaultMessage: 'Filled Impressions',
  },
  'reportMetadataColumns.AdClicks': { id: 'reportMetadataColumns.AdClicks', defaultMessage: 'Clicks' },
  'reportMetadataColumns.AdCTR': { id: 'reportMetadataColumns.AdCTR', defaultMessage: 'CTR' },
  'reportMetadataColumns.AdECPM': { id: 'reportMetadataColumns.AdECPM', defaultMessage: 'eCPM' },
  'reportMetadataColumns.ViewableImpressions': {
    id: 'reportMetadataColumns.ViewableImpressions',
    defaultMessage: 'Viewable Impressions',
  },
  'reportMetadataColumns.MeasurableImpressions': {
    id: 'reportMetadataColumns.MeasurableImpressions',
    defaultMessage: 'Measurable Impressions',
  },
  'reportMetadataColumns.ImpressionsRate': {
    id: 'reportMetadataColumns.ImpressionsRate',
    defaultMessage: 'Impressions %',
  },
  'reportMetadataColumns.EligibleImpressions': {
    id: 'reportMetadataColumns.EligibleImpressions',
    defaultMessage: 'Eligible Impressions',
  },
  'reportMetadataColumns.MeasurableImpressionsRate': {
    id: 'reportMetadataColumns.MeasurableImpressionsRate',
    defaultMessage: 'Measurable Impressions %',
  },
  'reportMetadataColumns.ResponsesServed': {
    id: 'reportMetadataColumns.ResponsesServed',
    defaultMessage: 'Responses Served',
  },
  'reportMetadataColumns.Date': { id: 'reportMetadataColumns.Date', defaultMessage: 'Date' },
  'reportMetadataColumns.AdUnitId': {
    id: 'reportMetadataColumns.AdUnitId',
    defaultMessage: 'Ad Unit id',
  },

  'reportMetadataColumns.OperatingSystem': {
    id: 'reportMetadataColumns.OperatingSystem',
    defaultMessage: 'Operating System',
  },
  'reportMetadataColumns.SiteName': { id: 'reportMetadataColumns.SiteName', defaultMessage: 'Site' },

  'reportMetadataColumns.AccountId': { id: 'reportMetadataColumns.AccountId', defaultMessage: 'Account Id' },
  'reportMetadataColumns.PublisherId': { id: 'reportMetadataColumns.PublisherId', defaultMessage: 'Publisher Id' },
  'reportMetadataColumns.PublisherName': { id: 'reportMetadataColumns.PublisherName', defaultMessage: 'Publisher Name' },
  'reportMetadataColumns.SiteId': { id: 'reportMetadataColumns.SiteId', defaultMessage: 'Site Id' },
  'reportMetadataColumns.AdDistribution': { id: 'reportMetadataColumns.AdDistribution', defaultMessage: 'AdDistribution' },
  'reportMetadataColumns.RequestedLanguage': { id: 'reportMetadataColumns.RequestedLanguage', defaultMessage: 'Requested Language' },
  'reportMetadataColumns.RequestedCountry': { id: 'reportMetadataColumns.RequestedCountry', defaultMessage: 'Requested Country' },
  'reportMetadataColumns.WebsiteCountry': { id: 'reportMetadataColumns.WebsiteCountry', defaultMessage: 'Website Country' },
  'reportMetadataColumns.WebsiteLanguage': { id: 'reportMetadataColumns.WebsiteLanguage', defaultMessage: 'Website Language' },
  'reportMetadataColumns.UserCountry': { id: 'reportMetadataColumns.UserCountry', defaultMessage: 'User Country' },
  'reportMetadataColumns.DistributionPartnerCode': {
    id: 'reportMetadataColumns.DistributionPartnerCode',
    defaultMessage: 'Distribution Partner Code',
  },
  'reportMetadataColumns.FormCode': { id: 'reportMetadataColumns.FormCode', defaultMessage: 'Form Code' },

  'reportMetadataColumns.RawSRPVs': { id: 'reportMetadataColumns.RawSRPVs', defaultMessage: 'Raw SRPVs' },
  'reportMetadataColumns.NonBillableSRPVs': { id: 'reportMetadataColumns.NonBillableSRPVs', defaultMessage: 'Non-billable SRPVs' },
  'reportMetadataColumns.AdDensity': { id: 'reportMetadataColumns.AdDensity', defaultMessage: 'Ad Density' },
  'reportMetadataColumns.BiddedRPM': { id: 'reportMetadataColumns.BiddedRPM', defaultMessage: 'Bidded RPM' },
  'reportMetadataColumns.BiddedCTR': { id: 'reportMetadataColumns.BiddedCTR', defaultMessage: 'Bidded CTR' },
  'reportMetadataColumns.BiddedSRPVs': { id: 'reportMetadataColumns.BiddedSRPVs', defaultMessage: 'Bidded SRPVs' },
  // 'reportMetadataColumns.BiddedSRPVs': { id: 'reportMetadataColumns.BiddedSRPVs', defaultMessage: 'Impressions' },
  'reportMetadataColumns.EstimatedRevenueInUSD': {
    id: 'reportMetadataColumns.EstimatedRevenueInUSD',
    defaultMessage: 'Estimated Revenue in USD',
  },
  'reportMetadataColumns.EstimatedRevenue': { id: 'reportMetadataColumns.EstimatedRevenue', defaultMessage: 'Estimated Revenue' },
  'reportMetadataColumns.CPC': { id: 'reportMetadataColumns.CPC', defaultMessage: 'CPC' },
  'reportMetadataColumns.TypeTag': { id: 'reportMetadataColumns.TypeTag', defaultMessage: 'Type Tag' },
  'reportMetadataColumns.PTQS': { id: 'reportMetadataColumns.PTQS', defaultMessage: 'PTQS' },
  'reportMetadataColumns.PartnerCode': { id: 'reportMetadataColumns.PartnerCode', defaultMessage: 'Partner Code' },
  'reportMetadataColumns.PartnerTag': { id: 'reportMetadataColumns.PartnerTag', defaultMessage: 'Partner Tag' },
  'reportMetadataColumns.AdCountry': { id: 'reportMetadataColumns.AdCountry', defaultMessage: 'Ad Country' },
  'reportMetadataColumns.DeviceType': { id: 'reportMetadataColumns.DeviceType', defaultMessage: 'Device Type' },
  'reportMetadataColumns.ImpactScore': { id: 'reportMetadataColumns.ImpactScore', defaultMessage: 'Impact Score' },
  'reportMetadataColumns.Device': { id: 'reportMetadataColumns.Device', defaultMessage: 'Device' },
  'reportMetadataColumns.Market': { id: 'reportMetadataColumns.Market', defaultMessage: 'Market' },
  'reportMetadataColumns.P50_Latency_ms': { id: 'reportMetadataColumns.P50_Latency_ms', defaultMessage: 'P50 Page Load Time' },
  'reportMetadataColumns.P50_Latency_ms_7DMA': {
    id: 'reportMetadataColumns.P50_Latency_ms_7DMA',
    defaultMessage: 'P50 Page Load Time (7-Day Average)',
  },
  'reportMetadataColumns.P90_Latency_ms': { id: 'reportMetadataColumns.P90_Latency_ms', defaultMessage: 'P90 Page Load Time' },
  'reportMetadataColumns.P90_Latency_ms_7DMA': {
    id: 'reportMetadataColumns.P90_Latency_ms_7DMA',
    defaultMessage: 'P90 Page Load Time (7-Day Average)',
  },
  'reportMetadataColumns.RedirectionPhase': { id: 'reportMetadataColumns.RedirectionPhase', defaultMessage: 'Redirection Phase' },
  'reportMetadataColumns.PTQSRemediationStatus': {
    id: 'reportMetadataColumns.PTQSRemediationStatus',
    defaultMessage: 'PTQS Remediation Status',
  },
  'reportMetadataColumns.NumberOfWeeks': { id: 'reportMetadataColumns.NumberOfWeeks', defaultMessage: 'Number of Weeks' },
  'reportMetadataColumns.ModifiedDate': { id: 'reportMetadataColumns.ModifiedDate', defaultMessage: 'Modified Date' },
  'reportMetadataColumns.Action': { id: 'reportMetadataColumns.Action', defaultMessage: 'Action' },
  'reportMetadataColumns.SelectTierEligibilityStatus': {
    id: 'reportMetadataColumns.SelectTierEligibilityStatus',
    defaultMessage: 'Select Status',
  },
  'reportMetadataColumns.PreviousSelectTierEligibilityStatus': {
    id: 'reportMetadataColumns.PreviousSelectTierEligibilityStatus',
    defaultMessage: 'Previous Select Status',
  },
  'reportMetadataColumns.SelectTierDowngradeReason': {
    id: 'reportMetadataColumns.SelectTierDowngradeReason',
    defaultMessage: 'Eligibility Reason',
  },
  'reportMetadataColumns.SiteUrl': { id: 'reportMetadataColumns.SiteId', defaultMessage: 'Site URL' },
  'reportMetadataColumns.SRPV': { id: 'reportMetadataColumns.SRPV', defaultMessage: 'SRPV' },
  'reportMetadataColumns.ARPV': { id: 'reportMetadataColumns.ARPV', defaultMessage: 'ARPV' },
  'reportMetadataColumns.CreationDate': { id: 'reportMetadataColumns.CreationDate', defaultMessage: 'Creation Date' },
  'reportMetadataColumns.ClickYield': { id: 'reportMetadataColumns.ClickYield', defaultMessage: 'Click Yield' },
  'reportMetadataColumns.Coverage': { id: 'reportMetadataColumns.Coverage', defaultMessage: 'Coverage' },
  'reportMetadataColumns.AdImpressions': { id: 'reportMetadataColumns.AdImpressions', defaultMessage: 'Ad Impressions' },
  'reportMetadataColumns.RPM': { id: 'reportMetadataColumns.RPM', defaultMessage: 'RPM' },
  'reportMetadataColumns.AdLanguage': { id: 'reportMetadataColumns.AdLanguage', defaultMessage: 'Ad Language' },
  'reportMetadataColumns.Browser': { id: 'reportMetadataColumns.Browser', defaultMessage: 'Browser' },
  'reportMetadataColumns.FollowOnType': { id: 'reportMetadataColumns.FollowOnType', defaultMessage: 'Follow On Type' },
  'reportMetadataColumns.AdImpressionYield': { id: 'reportMetadataColumns.AdImpressionYield', defaultMessage: 'Ad Impression Yield' },
  'reportMetadataColumns.TrafficTier': { id: 'reportMetadataColumns.TrafficTier', defaultMessage: 'Traffic Tier' },
  'reportMetadataColumns.ContentExperience': { id: 'reportMetadataColumns.ContentExperience', defaultMessage: 'Content Experience' },
  'reportMetadataColumns.MarketCountry': { id: 'reportMetadataColumns.MarketCountry', defaultMessage: 'Market Country' },
  'reportMetadataColumns.MarketLanguage': { id: 'reportMetadataColumns.MarketLanguage', defaultMessage: 'Market Language' },
  'reportMetadataColumns.ContentVertical': { id: 'reportMetadataColumns.ContentVertical', defaultMessage: 'Content Vertical' },
  'reportMetadataColumns.ContentType': { id: 'reportMetadataColumns.ContentType', defaultMessage: 'Content Type' },
  'reportMetadataColumns.PageViews': { id: 'reportMetadataColumns.PageViews', defaultMessage: 'Page Views' },
  'reportMetadataColumns.UniqueUsers': { id: 'reportMetadataColumns.UniqueUsers', defaultMessage: 'Unique Users' },
  'reportMetadataColumns.Experience': { id: 'reportMetadataColumns.Experience', defaultMessage: 'Experience' },
  'reportMetadataColumns.NetRevenue': { id: 'reportMetadataColumns.NetRevenue', defaultMessage: 'Net Revenue' },
  'reportMetadataColumns.StartDistributionRPM': {
    id: 'reportMetadataColumns.StartDistributionRPM',
    defaultMessage: 'Start Distribution RPM',
  },
  'reportMetadataColumns.RevenueSharePercent': { id: 'reportMetadataColumns.RevenueSharePercent', defaultMessage: 'Revenue Share Percent' },
  'reportMetadataColumns.TotalPartnerRevenueShare': {
    id: 'reportMetadataColumns.TotalPartnerRevenueShare',
    defaultMessage: 'Total Partner Revenue Share',
  },
  'reportMetadataColumns.Queries': {
    id: 'reportMetadataColumns.Queries',
    defaultMessage: 'Queries',
  },
  'reportMetadataColumns.AccountNumber': {
    id: 'reportMetadataColumns.AccountNumber',
    defaultMessage: 'Account Number',
  },
});
